import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyChxdn8POrH78wYTHFT8H_eDipA6XWr0Ls",
  authDomain: "ambhos-webapp.firebaseapp.com",
  projectId: "ambhos-webapp",
  storageBucket: "ambhos-webapp.appspot.com",
  messagingSenderId: "1068794964970",
  appId: "1:1068794964970:web:22eed427cf3054c185e093",
  measurementId: "G-J0WL8ZK3DG",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const googleAuthProvider = new GoogleAuthProvider();

export { app, analytics, auth, googleAuthProvider, signInWithPopup };
